import { createContext } from 'react';

export enum DialogType {
  FRONTLINE_BUY_NOW_SUBMIT = 'FRONTLINE_BUY_NOW_SUBMIT',
}
export interface DialogContextInterface {
  /**
   * Get all currently registered dialog registrations (useful for debugging)
   * @returns Array of registered dialog registration keys
   */
  getRegisteredDialogs: () => Array<string>;

  /**
   * Check if a dialog is currently registered for a specific dialog type and target ID
   * @param dialogType - The type of dialog to check
   * @param targetId - The target ID to check
   * @returns true if the dialog is registered and available
   */
  isDialogAvailable: (dialogType: DialogType, targetId: string) => boolean;

  /**
   * Register a dialog trigger function
   * @param registration - Dialog registration parameters
   * @returns Cleanup function to unregister the trigger
   */
  registerDialog: (registration: DialogRegistration) => () => void;

  /**
   * Subscribe to registry changes to get notified when dialogs are registered/unregistered
   * @param callback - Function to call when registry changes
   * @returns Cleanup function to stop listening to changes
   */
  subscribeToRegistryChanges: (callback: () => void) => () => void;

  /**
   * Trigger a dialog of the specified type for a specific target ID
   * @param dialogType - The type of dialog to trigger
   * @param targetId - The target ID for the dialog instance
   * @returns true if dialog was triggered, false if no dialog is registered
   */
  triggerDialog: (dialogType: DialogType, targetId: string) => boolean;
}

export interface DialogRegistration {
  /**
   * The dialog type to register
   */
  dialogType: DialogType;
  /**
   * Function to execute when dialog is triggered
   */
  onTrigger: () => void;
  /**
   * Target ID for this specific dialog instance
   */
  targetId: string;
}

export const DialogTriggerContext = createContext<DialogContextInterface | undefined>(undefined);
